// Functie zorgt ervoor dat elke class met "100vh" de daadwerkelijke viewheight heeft, ook op Safari mobile.
$(window).on('resize', function() {
  let is_small_screen = window.innerWidth <= 768;
  if (!is_small_screen) {
      $('.100vh').css('height', window.innerHeight + 'px');
  } else {
      $('.100vh').css('height', '');
  }
});
